import React from 'react';
import {
  Box,
  Button,
  Tag,
  TagLabel,
  TagCloseButton,
  useBreakpointValue,
  Flex,
  Heading
} from '@chakra-ui/react';
import HeaderFont from '@components/atoms/HeaderFont';

const FilterHeader = ({
  title = ``,
  appliedFilters = [],
  onFilterToggle = () => {},
  onClearAllFilters = () => {},
  onTagClosed = (id) => {}
}) => {
  const isDesktop = useBreakpointValue({ base: false, md: true });
  return (
    <Box width="100%">
      <Flex align="center" direction={{ base: `column`, xs: `row` }}>
        <Heading
          as="h4"
          width="100%"
          textAlign={{ base: `left`, md: `center` }}
          textTransform="uppercase"
          fontSize={{ base: `4xl`, md: `5xl` }}
          fontWeight="900"
          wordBreak="break-word"
          color="purple.600"
          lineHeight={{ base: `2.688rem`, md: `3rem` }}>
          {title}
        </Heading>
        <Box
          m="auto 0 .8rem auto"
          style={{
            display: isDesktop ? `none` : `block`
          }}>
          <Button
            variant="ghost"
            size={{ base: `sm`, md: `md` }}
            onClick={onFilterToggle}>
            <HeaderFont fontWeight="700" textTransform="uppercase">
              Filter
            </HeaderFont>
          </Button>
        </Box>
      </Flex>
      <Flex
        pb={{ base: appliedFilters.length > 0 ? `1rem` : `0`, md: `0` }}
        pt={{ base: appliedFilters.length > 0 ? `1rem` : `0` }}>
        <Box width="100%">
          {appliedFilters.map((filter, i) => (
            <Tag
              key={`appliedFilters${i + 1}`}
              size={{ base: `sm`, md: `md` }}
              mr=".5rem"
              borderRadius="full"
              variant="solid"
              colorScheme="purple">
              <TagLabel>
                <Box fontWeight="600">{filter.title}</Box>
              </TagLabel>
              <TagCloseButton onClick={() => onTagClosed(filter.id)} />
            </Tag>
          ))}
        </Box>
        {appliedFilters.length > 0 && (
          <Box>
            <Button
              size={{ base: `xs`, md: `short` }}
              variant="link"
              onClick={onClearAllFilters}>
              <HeaderFont fontWeight="700" textTransform="uppercase">
                Clear All
              </HeaderFont>
            </Button>
          </Box>
        )}
      </Flex>
    </Box>
  );
};

export default FilterHeader;
